import React from 'react';
import $ from 'jquery';
import 'jquery-ui-dist/jquery-ui';
import './Css/themes/base/all.css';
import logo from '../logo.svg';
import '../App.css';
import './Css/trafico.css';
import './Css/rolesResponsive.css';
import Menu from '../Modulos/Menu';
import BarraPrincipal from '../Modulos/BarraPrincipal';
import { MDBRow, MDBCol } from 'mdb-react-ui-kit';
import { FaSearch } from "@react-icons/all-files/fa/FaSearch";
import { FaFilter } from "@react-icons/all-files/fa/FaFilter";
import axios from '../utils/axiosConfig';
import Swal from 'sweetalert2';
import ModalBaseLg from '../components/modals/modal-base-lg';
import ModalPermissions from '../components/maestros/modals/modalPermissions';
import { FaPlus } from "@react-icons/all-files/fa/FaPlus";
import { FaSync } from "@react-icons/all-files/fa/FaSync"; // o el que quieras
import ModalPermissionsByRole from '../components/maestros/modals/modalPermissionsByRole';
import '../Pages/Css/modalPermisosRoles.css';
import ModalBaseSm from '../components/modals/modal-base-sm';
import ModalRoles from '../components/maestros/modals/modalRoles';
import BaseModalXXL from '../components/modals/baseModalXXL';


var table;
var miStorage = window.localStorage;
class Roles extends React.Component {
  constructor(props) {
    super(props);
    this.ListarRoles = this.ListarRoles.bind(this);
    this.state = {
      listRoles: [],
      bitOpen: false,
      bitInsert: false,
      bitEdit: false,
      bitDelete: false,
      showModalRoles: false,
      showModalPermissions: false,
      showModalPermissionsByRole: false,
      dataRole: null,
      idEditRole: -1,
      idEditPermission: -1,
      searchTerm: "",
    };
    this.HandlePageByRole();
    this.ListarRoles();
  }

  componentDidUpdate() {
    $('#search').keyup();

  }
  componentDidMount() {
    document.body.classList.add('roles-responsive-page');
    document.documentElement.classList.add('roles-page-lock');
    $("#success-alert").hide();
    $("#danger-alert").hide();

    // $("#search").on("keyup", function () {
    //   var value = $(this).val().toLowerCase();
    //   $("#tabladata tr").filter(function () {
    //     $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
    //   });
    // });
  }

  componentWillUnmount() {
    document.body.classList.remove('roles-responsive-page');
    document.documentElement.classList.remove('roles-page-lock');
  }

  toggleNavigationMenu = () => {
    document.querySelector('[class*="sidenav-toggle"]')?.click();
  };

  // METODO PARA OBTENER LISTADO DE EVENTOS POR PROYECTO
  ListarRoles() {
    axios.get(process.env.REACT_APP_SERVER + '/operaciones/getroles', {
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('tkn')}` },
      withCredentials: 'true'
    })
      .then(res => {
        if (res.data.success === false) {
          window.location = "/";
        } else {
          // console.log(res.data.data);
          console.log("Roles: ", res.data.data);
          this.setState({ listRoles: res.data.data });
        }
      })
  }

  HandlePageByRole = async () => {
    let data = {
      pagina: "11",
    };

    try {
      const res = await axios.post(
        process.env.REACT_APP_SERVER + "/usuarios/getconfiguracionpagina",
        JSON.stringify(data),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("tkn")}`,
          },
          withCredentials: true, // this should be inside the options object
        }
      );

      // Handle the response here after the request completes
      if (res.data.success === false) {
        window.location = "/";
      } else {
        // console.log("BIt permisos: ", res.data.data);
        if (res.data.data.length > 0) {
          this.setState({
            bitOpen: res.data.data[0].bitOpen,
            bitInsert: res.data.data[0].bitInsert,
            bitEdit: res.data.data[0].bitEdit,
            bitDelete: res.data.data[0].bitDelete,
          }, () => {
            if (this.state.bitOpen) {
              console.warn("Tienes todos los permisos");

              return
            } else {
              Swal.fire({
                title: 'Información',
                text: 'No tiene los permisos necesarios para acceder a esta página',
                icon: 'info',
                timer: 3000, // The time in milliseconds before the alert closes (3 seconds in this case)
                showConfirmButton: false,
                allowOutsideClick: false, // Prevents clicking outside the modal to close it
                didOpen: () => {
                  Swal.showLoading(); // Shows the loading spinner
                },
                timer: 3000 // Time before redirecting (3 seconds)
              }).then(() => {
                // This will execute after the modal finishes showing
                window.location.href = "/principal"; // Redirect to another page
              });
            }

          })
        }

      }
    } catch (error) {
      console.error("Error al listar bit permisos:", error);
    }
  };

  handleCreate = (data) => {
    this.setState({ dataRole: data });
    this.setState({ showModalRoles: true });
  }

  OpenEdit = (data) => {
    this.setState({ idEditRole: data.IDRol });
    this.setState({ dataRole: data });
    this.setState({ showModalRoles: true });
    console.log("Editar rol: ", data);
  }

  handleCreate2 = (data) => {
    this.setState({ dataRole: data });
    this.setState({ showModalPermissions: true });
  }


  OpenPermisos(data) {
    this.setState({ dataRole: data });
    this.setState({ showModalPermissionsByRole: true });
    console.log("Mostrar permisos para el rol: ", data);
  }


  onCloseModalPermissions = () => {
    this.setState({ showModalPermissions: false });
  }

  onCloseModalPermissionsByRole = () => {
    this.setState({ showModalPermissionsByRole: false });
  }

  onCloseModalRoles = () => {
    this.setState({ showModalRoles: false });
    this.ListarRoles();
    this.setState({ idEditRole: -1 });
  }

  handleSearchChange = (e) => {
    this.setState({ searchTerm: e.target.value });
  };



  render() {
    const { listRoles, searchTerm } = this.state;

    const filteredRoles = listRoles.filter((role) => {
      const text = (
        (role.IDRol ?? "") +
        " " +
        (role.NombreRol ?? "")
      ).toString().toLowerCase();
      // console.log("Texto a buscar:", filteredRoles);

      return text.includes(searchTerm.toLowerCase());
    });
    return (
      <>
        <div className="layout-wrapper layout-content-navbar roles-page">
          <div className="layout-container">


            <div className="layout-page">
              <BarraPrincipal onToggleNavigation={this.toggleNavigationMenu} />
              {this.state.bitOpen && (
                <div className="content-wrapper">

                  <div className="container-fluid flex-grow-1 container-p-y">
                    <MDBRow className="align-items-center g-3 roles-toolbar">
                      <MDBCol md="9" className="roles-toolbar-actions">
                        <div className="d-flex align-items-center gap-2 flex-wrap buttonsRole">
                          <h4 className="fw-bold mb-0 nombreRol">Roles</h4>

                          {(this.state.bitInsert || this.state.bitOpen) && (
                            <button
                              type="button"
                              className="btn-primary-modals-permisos-roles"
                              onClick={this.handleCreate}
                            >
                              <FaPlus style={{ marginRight: 6 }} />
                              NUEVO ROL
                            </button>
                          )}

                          <button
                            type="button"
                            className="btn-primary-modals-permisos-roles"
                            onClick={this.handleCreate2}
                          >
                            <FaPlus style={{ marginRight: 6 }} />
                            NUEVA PÁGINA
                          </button>
                        </div>
                      </MDBCol>

                      <MDBCol md="3" className="roles-toolbar-search">
                        <div className="input-group col-md-12 roles-search">
                          <span className="input-group-text" id="b1"><FaSearch /></span>
                          <input
                            id="search"
                            type="text"
                            className="form-control"
                            placeholder="Filtrar"
                            aria-describedby="b1"
                            value={this.state.searchTerm}        
                            onChange={this.handleSearchChange}     
                          />

                        </div>
                      </MDBCol>

                      {/* <MDBCol md="1">
                        <button
                          className="btn btn-outline-secondary"
                          type="button"
                          data-bs-toggle="offcanvas"
                          data-bs-target="#offcanvasEnd"
                          aria-controls="offcanvasEnd"
                        >
                          <FaFilter />
                        </button>
                      </MDBCol> */}
                    </MDBRow>


                    <div className="card" style={{ marginTop: 20 }}>
                      <div className="table-responsive text-nowrap rolesTable roles-desktop-list">
                        <table className="table table-hover" id="tabla">
                          <thead className="FondoHeaderTabla2">
                            <tr>
                              <th style={{ color: '#ffffff' }}>ID</th>
                              <th style={{ color: '#ffffff' }}>NOMBRE</th>
                              <th style={{ color: '#ffffff' }}>OPCIONES</th>
                            </tr>
                          </thead>
                          <tbody className="table-border-bottom-0" id="tabladata">
                            {this.loadFillData(filteredRoles)}
                          </tbody>
                        </table>
                      </div>
                      <div className="roles-mobile-list" aria-label="Lista de roles">
                        {this.renderMobileRoles(filteredRoles)}
                      </div>
                    </div>
                  </div>

                  <footer className="content-footer footer bg-footer-theme">
                    <div className="container-xxl d-flex flex-wrap justify-content-between py-2 flex-md-row flex-column">
                      <div className="mb-2 mb-md-0">
                        ©, Producto realizado por <a href="https://logiseguridad.com" target="_blank" className="footer-link fw-bolder"> Logiseguridad Ltda</a>
                      </div>

                    </div>
                  </footer>

                  <div className="content-backdrop fade"></div>
                </div>
              )}
            </div>
          </div>

          <div className="layout-overlay layout-menu-toggle"></div>
        </div>

        <div className="alert alert-success" id="success-alert">
          <strong>Exitoso! </strong> Los cambios han sido realizados con exito.
        </div>

        <div className="alert alert-danger" id="danger-alert">
          <strong>Error! </strong> Se ha presentado un error, valide la información.
        </div>

        <ModalBaseSm
          isOpen={this.state.showModalRoles}
          title={this.state.idEditRole === -1 ? 'Creación de nuevo rol' : 'Edición de rol'}
          onClose={this.onCloseModalRoles}
          childComponent={<ModalRoles onClose={this.onCloseModalRoles} idEditRole={this.state.idEditRole} data={this.state.dataRole} />}
        />

        <ModalBaseLg
          isOpen={this.state.showModalPermissions}
          title={'Creacion de páginas'}
          onClose={this.onCloseModalPermissions}
          childComponent={<ModalPermissions />}
        />

        <BaseModalXXL
          isOpen={this.state.showModalPermissionsByRole}
          title={'Creacion de permisos por rol'}
          onClose={this.onCloseModalPermissionsByRole}
          className="mpr-modal"
        >
          <ModalPermissionsByRole data={this.state.dataRole} />
        </BaseModalXXL>

      </>


    );
  }

  loadFillData(array) {


    return array.map((data) => {

      return (
        <tr key={data.IDRol}>
          <td className="prueba"><strong>{data.IDRol}</strong></td>
          <td>{data.NombreRol}</td>
          <td>
            <div className="dropdown position-static">
              <button type="button" className="btn p-0 dropdown-toggle hide-arrow" data-bs-toggle="dropdown">
                <i className="bx bx-dots-vertical position-static"></i>
              </button>
              <div className="dropdown-menu">
                <span onClick={() => this.OpenEdit(data)} className="dropdown-item">
                  <i className="bx bx-edit me-1"></i> Editar
                </span>
                <span onClick={() => this.OpenPermisos(data)} className='dropdown-item'>
                  <i className="bx bx-file me-1"></i> Ver Permisos
                </span>
              </div>
            </div>
          </td>

        </tr>
      )
    });
    $('.dropdown-toggle').dropdown();

  }

  renderMobileRoles(array) {
    if (!array.length) {
      return <div className="roles-mobile-empty">No se encontraron roles.</div>;
    }

    return array.map((data) => (
      <article className="role-mobile-card" key={data.IDRol}>
        <div className="role-mobile-card-header">
          <span className="role-mobile-card-id">ID {data.IDRol}</span>
          <i className="bx bx-shield-quarter" aria-hidden="true" />
        </div>
        <div className="role-mobile-card-content">
          <span className="role-mobile-card-label">Nombre del rol</span>
          <h3>{data.NombreRol || 'Sin nombre'}</h3>
          <div className="role-mobile-card-meta">
            <span><i className="bx bx-key" aria-hidden="true" /> Identificador</span>
            <strong>ROL-{data.IDRol}</strong>
          </div>
        </div>
        <div className="role-mobile-card-actions">
          <button type="button" onClick={() => this.OpenEdit(data)}>
            <i className="bx bx-edit-alt" aria-hidden="true" /> Editar
          </button>
          <button type="button" onClick={() => this.OpenPermisos(data)}>
            <i className="bx bx-file" aria-hidden="true" /> Ver permisos
          </button>
        </div>
      </article>
    ));
  }
}

export default Roles;
